import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class SubDomainService {
  private activeCompanyMethod: Subject<void> = new Subject<void>();
  domain:any=environment.domain
  CentralDomain:any=environment.centralDomain
  constructor(
  ) { }

  // invokeUpdatedSubdomain(subDomainName:any) {
  //   this.activeCompanyMethod.next(subDomainName);
  // }

  getUpdatedActiveSubdomain() {
    let subDomain = window.location.origin.split('://')[1].split('.')[0];
    if(window.location.origin.includes(`.${this.domain}`) && (subDomain != this.CentralDomain || !this.CentralDomain)){
      return window.location.origin.split('://')[1].split('.')[0] && subDomain != 'dashboard' ? window.location.origin.split('://')[1].split('.')[0]  : null ;
    }
    return '';
  }

}
